import { broadcast, broadcastChannels } from '@common/helpers/broadcast';

// FINISHED with no SUCCESS called indicates failure
export const waitForTransferToUserCashoutResponse = () => new Promise((resolve) => {
  const onCashoutSucceed = () => {
    resolve({ success: true });

    broadcast.removeEventListener(
      broadcastChannels.ReceiveDepositToClientAccountFinished,
      // eslint-disable-next-line
      onCashoutFinished,
    );
  };

  const onCashoutFinished = () => {
    resolve({ success: false });

    broadcast.removeEventListener(
      broadcastChannels.ReceiveDepositToClientAccountSuccess,
      onCashoutSucceed,
    );
  };

  broadcast.addEventListener(
    broadcastChannels.ReceiveDepositToClientAccountSuccess,
    onCashoutSucceed,
    { once: true },
  );

  broadcast.addEventListener(
    broadcastChannels.ReceiveDepositToClientAccountFinished,
    onCashoutFinished,
    { once: true },
  );
});
